export default {
  existing_documents: {
    description: 'Ya ha subido los siguientes documentos. Seleccione uno y pulse enviar, o suba un nuevo documento.',
    sides: {
      front: 'Anverso',
      back: 'Reverso',
    },
    created_at: 'Subido: {{date}}',
    expires_at: 'Vence: {{date}}',
  },
  document_types: {
    owner_document: 'Documento de identidad del titular',
    business_document: 'Documento comercial',
  },
  form: {
    document_type: {
      label: 'Justificante de actividad empresarial',
      placeholder: 'Seleccionar tipo de documento',
      options: {
        vat_registration: 'Registro de IVA',
        trade_registration: 'Registro mercantil',
        trade_license: 'Licencia comercial',
        commercial_register_extract: 'Extracto del registro comercial',
        financial_statements: 'Estados financieros',
        other: 'Otro',
      },
    },
    front: {
      label: 'Anverso del documento',
    },
    back: {
      label: 'Reverso del documento (opcional para algunos)',
    },
    expires_at: {
      label: 'Fecha de vencimiento del documento',
      placeholder: 'Seleccionar fecha de vencimiento',
    },
  },
  buttons: {
    select_file: 'Seleccionar archivo',
    next: 'Siguiente',
    back: 'Reverso',
    send: 'Enviar',
    upload_new: 'Subir nuevo documento',
    use_existing: 'Usar un documento subido',
  },
};
